import React from "react";
import { Popup } from "semantic-ui-react";

import { Button } from "../components/tailwind";
import { LanguageCode } from "../customers/customerlanguages";
import { popupDelay } from "../customers/gpt/types";

export type SourceMenuItem = {
  languageCode: LanguageCode;
  text: string;
  disabled?: boolean;
  onClick: () => void;
};

// "Set {language} as source" button; when disabled it doubles as the
// current-source indicator. Renders nothing when `item` is undefined
// (the language cannot become a source yet).
export const SetSourceButton: React.FC<{ item?: SourceMenuItem }> = ({
  item,
}) => {
  if (!item) return null;
  return (
    <Popup
      mouseEnterDelay={popupDelay}
      content={
        item.disabled
          ? "This language is the source for translation"
          : item.text
      }
      size="small"
      trigger={
        // Disabled buttons swallow mouse events; the span keeps the popup working.
        <span className="tw-ms-1">
          <Button
            // The widget can be mounted inside a legacy Django <form>; without
            // an explicit type the browser submits that form on click.
            type="button"
            variant="secondary-alt"
            size="sm"
            compact
            disabled={item.disabled}
            onClick={item.onClick}
            data-testid={`set-source-${item.languageCode}`}
          >
            {item.disabled ? "Source" : "Set as source"}
          </Button>
        </span>
      }
    />
  );
};
